<template>
  <div class="progress-container">
    <div class="progress" :class="`${unique}1`"></div>
    <div class="progress" :class="`${unique}2`"></div>
    <div class="progress" :class="`${unique}3`"></div>
    <div class="progress" :class="`${unique}4`"></div>
    <div class="progress" :class="`${unique}5`"></div>
    <div class="progress" :class="`${unique}6`"></div>
    <div class="progress" :class="`${unique}7`"></div>
    <div class="progress" :class="`${unique}8`"></div>
    <div class="progress" :class="`${unique}9`"></div>
    <div class="progress" :class="`${unique}10`"></div>
  </div>
</template>

<script>
  export default {
    props: {
      unique: {
        type: String,
        default: 'p'
      },
      value: {
        type: Number,
        default: 0
      },
    },
    mounted() {
      const progressTill = +((this.value / 10).toFixed(0))
      let value = this.value
      for (let i = 1; i <= progressTill; i++) {
        if (value > 10) {
          value -= 10
          document.styleSheets[0].addRule(`.${this.unique}${i}:before`, `width: 100%;`);
        } else {
          document.styleSheets[0].addRule(`.${this.unique}${i}:before`, `width: ${value * 10}%;`);
        }
      }
    }
  }
</script>

<style scoped>
.progress-container {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
}
.progress {
  position: relative;
  width: 15px;
  height: 15px;
  background: var(--v-primaryText-base);
  margin: 0px 2px;
}

.progress:before {
  position: absolute;
  content: '';
  height: 100%;
  background-color: var(--v-accent-base);
}
</style>